// 💾 routes/ProtectedRoute.tsx
import React from "react"
import { Navigate, useLocation, useParams } from "react-router-dom"
import { useAuthProfileGuard } from "../hooks/useAuthProfileGuard"

const ProtectedRoute = ({
  children,
  requiredRole,
  requireVerified = true
}: {
  children: React.ReactNode
  requiredRole?: "admin" | "client"
  requireVerified?: boolean
}) => {
  const { lng = "en" } = useParams()
  const location = useLocation()

  const {
    user,
    role,
    status,
    authLoading,
    profileLoading
  } = useAuthProfileGuard()

  if (authLoading || profileLoading) return <div>Loading...</div>

  // ✅ Not logged in
  if (!user) {
    return <Navigate to={`/${lng}/login`} state={{ from: location.pathname }} replace />
  }

  // ✅ Role mismatch
  if (requiredRole && role !== requiredRole) {
    console.log("❌ ROLE mismatch:", { role, requiredRole })
    return <Navigate to={`/${lng}/login`} replace />
  }

  // ✅ Verification required
  const onVerifyPage = location.pathname.endsWith("/verify")
  if (
    requireVerified &&
    role === "client" &&
    status !== "Verified" &&
    !onVerifyPage
  ) {
    return <Navigate to={`/${lng}/verify`} replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
